import { useState } from "react";
import { useAsync } from "../../../shared/hooks/useAsync";
import { useFormFields } from "../../../shared/hooks/useFormFields";
import { authenticationApi } from "../api/authentication.api";
import { isValid, validateFields } from "../validation/authentication.validation";
import { useSession } from "./useSession";

/**
 * Handles email/password login: validates fields, calls the login API,
 * and either establishes a session or triggers the OTP step when the
 * account requires it.
 */
export function useLogin({ onOtpRequired, onSuccess }) {
    const { fields, set } = useFormFields({ email: "", password: "" });
    const [fieldErrors, setFieldErrors] = useState({});
    const { run, loading, error } = useAsync();
    const { establishSession } = useSession();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validateFields(fields);
        setFieldErrors(errors);
        if (!isValid(errors)) return;

        const data = await run(() => authenticationApi.login(fields.email, fields.password));
        if (!data) return;

        if (data.otpRequired) {
            onOtpRequired?.();
            return;
        }

        if (data.token) {
            establishSession(data.token);
        }
        onSuccess?.();
    };

    return { fields, set, fieldErrors, loading, error, handleSubmit };
}
